/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1176
 */

var r = require(/* 1434 */"./1434")(Object.getPrototypeOf, Object)
module.exports = r
